import type { Environment } from 'config/environment'

import { apiClient } from 'modules/core/lib/mobx-rest'
import adapter from 'modules/core/lib/mobx-rest-axios-adapter'

export default ({ apiEndpoint, deploymentPhase }: Environment) => {
  apiClient(adapter, {
    apiPath: apiEndpoint,
    commonOptions: {
      withCredentials: true,
      headers: {
        'X-Factorial-Origin': 'web',
        'X-Deployment-Phase': deploymentPhase,
      },
    },
  })
}
